<agm-map *browser [disableDefaultUI]="false" [zoomControl]="false" [fitBounds]="true" [maxZoom]="maxZoom">
  <agm-marker [agmFitBounds]="true" *ngFor="let marker of markers" [latitude]="marker.lat" [longitude]="marker.lng">
    <agm-info-window><strong>{{ marker.name }}</strong></agm-info-window>
  </agm-marker>
</agm-map>
